import { RouteConfig } from "vue-router"

export const externalRoutes: RouteConfig[] = [
    {
        path: "external",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: {
            title: "moj_elektro.external",
            showMojElektroSidebar: true,
        },
        redirect: "external/integrations",
        children: [
            {
                path: "integrations",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: {
                    title: "moj_elektro.integrations",
                    maintainsContext: true,
                },
                children: [
                    {
                        path: "",
                        component: () => import("@/views/ExternalServices.vue"),
                        meta: {
                            title: "moj_elektro.integrations",
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "moj-elektro",
                        component: () => import("@/views/external/moj-elektro/MojElektro.vue"),
                        meta: {
                            title: "Moj Elektro",
                            showMojElektroSidebar: true,
                            maintainsContext: true,
                        },
                        redirect: "/external/integrations/moj-elektro/data",
                        children: [
                            {
                                path: "data",
                                component: () =>
                                    import("@/views/external/moj-elektro/tabs/DataTab.vue"),
                                meta: {
                                    title: "moj_elektro.data.title",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                            {
                                path: "calculations",
                                component: () =>
                                    import("@/views/external/moj-elektro/tabs/CalculationsTab.vue"),
                                meta: {
                                    title: "moj_elektro.calculations.title",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                            {
                                path: "comparison-charts",
                                component: () =>
                                    import(
                                        "@/views/external/moj-elektro/tabs/ComparisonChartsTab.vue"
                                    ),
                                meta: {
                                    title: "moj_elektro.comparison_charts.title",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                            {
                                path: "battery",
                                component: () =>
                                    import("@/views/external/moj-elektro/tabs/BatteryTab.vue"),
                                meta: {
                                    title: "moj_elektro.battery",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                            {
                                path: "solar",
                                component: () =>
                                    import("@/views/external/moj-elektro/tabs/SolarTab.vue"),
                                meta: {
                                    title: "moj_elektro.solar",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                            {
                                path: "management",
                                component: () =>
                                    import("@/views/external/moj-elektro/tabs/ManagementTab.vue"),
                                meta: {
                                    title: "moj_elektro.management",
                                    showMojElektroSidebar: true,
                                    maintainsContext: true,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
]
